import SyncController from "../APIController/SyncController"
import { getOffllineOrders, clearSyncOrders, saveOrders } from "../Model/Orders"
import { getOffllineOffers, clearSyncOffers } from "../Model/Offers"
import { saveProducts, getOffllineProducts, clearSyncProducts } from "../Model/Products"
import { saveCategories } from "../Model/Categories"
import { saveExtras } from "../Model/Extras"
import { saveDiscounts } from "../Model/Discounts"
import { saveOffers } from "../Model/Offers"
import { saveRegisterEntries, getOffllineRegisterEntries, clearSyncRegisterEntries } from "../Model/RegisterEntries"
import { saveWorkspaceUser } from "../Model/WorkspaceUser"
import { saveWorkspace } from "../Model/Workspace"
import { saveTimestamp, getTimestamp } from "../Model/TimeStamp"
import { saveOnlineTimeTracking, clearOfflineTimetracking, getOfflineTimeTracking } from "../Model/TimeTracking"

const SyncHelper = () => {
    const { ping, uploadDTO, uploadOffer, fetchOffers, fetchDiscounts, fetchCategories, fetchExtras, fetchOrders, fetchProducts, uploadProductStock, fetchRegisterEntries, uploadRegisterEntries, fetchWorkspaceUser, fetchWorkspace, fetchSyncTimestamp, fetchTimeTracking, uploadTimeTracking } = SyncController()

    const sync = async () => {
        await sendDataToServer()
    }

    const sendDataToServer = async () => {
        await sendOrders()
        await sendOffers()
        await sendProducts()
        await sendRegisterEntries()
        await sendTimeTracking()
    }

    const sendOrders = async () => {
        const orders = await getOffllineOrders();

        if (!orders || orders.length === 0) return;

        const payload = {
            orders: orders.map(({ productList, ...keep }) => keep)
        };

        try {
            const response = await uploadDTO(payload);
            if (response?.ok) {
                await clearSyncOrders();
            }
        } catch (err) {
            console.error("Upload fehlgeschlagen:", err);
        }
    }

    const sendOffers = async () => {
        const data = await getOffllineOffers();

        if (!data || data.length === 0) return;

        try {
            const response = await uploadOffer(data);
            if (response?.ok) {
                await clearSyncOffers();
            }
        } catch (err) {
            console.error("Upload fehlgeschlagen:", err);
        }
    }

    const sendProducts = async () => {
        const data = await getOffllineProducts()
        if (!data || data.length === 0) return;

        try {
            const response = await uploadProductStock(data);
            if (response?.ok) {
                await clearSyncProducts();
            }
        } catch (err) {
            console.error("Upload fehlgeschlagen:", err);
        }
    }

    const sendRegisterEntries = async () =>{
        const data = await getOffllineRegisterEntries()
        if (!data || data.length === 0) return;

        try {
            const response = await uploadRegisterEntries(data);
            if (response?.ok) {
                await clearSyncRegisterEntries();
            }
        } catch (err) {
            console.error("Upload fehlgeschlagen:", err);
        }
    }

    const sendTimeTracking = async () =>{
        const data = await getOfflineTimeTracking()
        if (!data || data.length === 0) return;

        try {
            const response = await uploadTimeTracking(data);
            if (response?.ok) {
                await clearOfflineTimetracking();
            }
        } catch (err) {
            console.error("Upload fehlgeschlagen:", err);
        }
    }

    const getDataFromServer = async () => {
        const timestamp = await fetchSyncTimestamp()
        const lastSynced = await getTimestamp()
        const needsSync = !lastSynced || new Date(timestamp) > new Date(lastSynced)
        if (needsSync) {
            await saveTimestamp(timestamp)
            const workspace = await fetchWorkspace()
            if (workspace) {
                await saveWorkspace(workspace)
            }
            const categories = await fetchCategories()
            if (categories) {
                await saveCategories(categories)
            }
            const products = await fetchProducts()
            if (products) {
                await saveProducts(products)
            }
            const extras = await fetchExtras()
            if (extras) {
                await saveExtras(extras)
            }
            const orders = await fetchOrders()
            if (orders) {
                await saveOrders(orders)
            }
            const discounts = await fetchDiscounts()
            if (discounts) {
                await saveDiscounts(discounts)
            }
            const offers = await fetchOffers()
            if (offers) {
                await saveOffers(offers)
            }
            const entries = await fetchRegisterEntries()
            if (entries) {
                saveRegisterEntries(entries)
            }
            const workspaceUser = await fetchWorkspaceUser()
            if (workspaceUser) {
                saveWorkspaceUser(workspaceUser)
            }
            const timeTracking = await fetchTimeTracking()
            if(timeTracking){
                saveOnlineTimeTracking(timeTracking)
            }
        }
    }

    const pingRequest = async (timeoutMs = 1000) => {
        const fetchPromise = ping();

        const timeoutPromise = new Promise((_, reject) =>
            setTimeout(() => reject(new Error("timeout")), timeoutMs)
        );

        try {
            const response = await Promise.race([fetchPromise, timeoutPromise]);
            return response?.ok || false;
        } catch {
            return false;
        }
    };



    return {
        sync,
        pingRequest,
        getDataFromServer
    }
}

export default SyncHelper